export default from './not-found-page';



// WEBPACK FOOTER //
// ./app/containers/not-found-page/index.js